export const FormatRut = (value) => {
    if (!value) return "";
    // eliminar puntos y guiones previos
    value = value.replace(/[^\dkK]/g, "").toUpperCase();

    // si el RUT es muy corto, no aplicar formato aún
    if (value.length <= 1) return value;

    const cuerpo = value.slice(0, -1);
    const dv = value.slice(-1);

    // agregar puntos cada 3 dígitos desde la derecha
    const cuerpoFormateado = cuerpo
        .split("")
        .reverse()
        .join("")
        .replace(/(\d{3})(?=\d)/g, "$1.")
        .split("")
        .reverse()
        .join("");

    return `${cuerpoFormateado}-${dv}`;
};
